module.exports = __webpack_public_path__ + "img/about.a604c018.jpg";